import { ListItemCore, ListItemCoreProps } from './ListItemCore';
import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
} from '../utils/OmakasePolymorphicComponent';
import Anchor from 'components/Anchor';
import React from 'react';

export type ListItemProps = ListItemCoreProps;

const ListItemDefaultElement = 'button';
type ListItemTypeGuard = 'button' | typeof Anchor;

const ListItem: OmakasePolymorphicComponent<
  ListItemProps,
  typeof ListItemDefaultElement,
  ListItemTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof ListItemDefaultElement>(
    {
      children,
      component,
      ...rest
    }: OmakasePolymorphicComponentProps<ListItemProps, E, ListItemTypeGuard>,
    ref: React.Ref<HTMLButtonElement> | undefined
  ) => {
    const Component: React.ElementType = component || ListItemDefaultElement;

    return (
      <ListItemCore ref={ref} component={Component} {...rest}>
        {children}
      </ListItemCore>
    );
  }
);

export default ListItem;
